import * as React from 'react';
import { useInputSize } from '../../../internal/hooks';
import { getInputAdornmentStyles } from '../../styles';
/**
 * Элемент с отступами для использования в качестве декорации инпута
 */
export function InputAdornment(_ref) {
  var children = _ref.children;
  var size = useInputSize();
  var styles = getInputAdornmentStyles(size);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['input-adornment']
  }, children);
}